import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { IconMail, IconRocket, IconGear, IconUsers, IconSearch } from '../components/Icons';
import './Support.css';

const Support: React.FC = () => {
  return (
    <div className="support-page mesh-gradient">
      <Hero
        title="Support"
        subtitle="We're here to help! Whether you have questions about our services, need technical support, or want to discuss a potential project, we'd love to hear from you."
      />

      <div className="support-container">

        <section className="support-section contact-info animate-fade-in-up">
          <h2>Contact Information</h2>
          <div className="contact-method glass">
            <div className="contact-icon icon-glow">
              <IconMail />
            </div>
            <div className="contact-details">
              <h3>Email Support</h3>
              <p>
                <a href="mailto:support@apresai.dev" className="support-email">
                  support@apresai.dev
                </a>
              </p>
              <p className="contact-description">
                Send us an email and we'll get back to you within 24 hours.
              </p>
            </div>
          </div>
        </section>

        <section className="support-section animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <h2>What We Can Help With</h2>
          <div className="help-topics">
            <Card
              variant="help"
              icon={<IconRocket />}
              title="Project Inquiries"
              description="Discuss your web or mobile application ideas and get started with Apres AI."
            />
            <Card
              variant="help"
              icon={<IconGear />}
              title="Technical Support"
              description="Get assistance with any technical issues or questions about our services."
            />
            <Card
              variant="help"
              icon={<IconUsers />}
              title="Partnerships"
              description="Explore collaboration opportunities and partnership inquiries."
            />
            <Card
              variant="help"
              icon={<IconSearch />}
              title="General Questions"
              description="Ask us anything about Apres AI, our approach, or our technologies."
            />
          </div>
        </section>

        <section className="support-section">
          <h2>About Apres AI</h2>
          <p>
            We're a small, AI-forward development team that specializes in rapidly
            transforming ideas into viable businesses through web and mobile applications.
            Our mission is to help innovators bring their visions to life quickly and
            efficiently.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Support;
